const hostingEnvironments = [
  {
    domain: 'kiosk-test.daotienhotel.com',
    kiosk: true,
    firebaseConfig: {
      apiKey: 'AIzaSyCft8yKpvCi5W2tgrNHXwHjuyKvF2HI1kE',
      authDomain: 'autopms-development.firebaseapp.com',
      databaseURL: 'https://autopms-development-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'autopms-development',
      storageBucket: 'autopms-development.appspot.com',
      messagingSenderId: '171175200549',
      appId: '1:171175200549:web:1ba75d5c76c71e2471fccc',
      measurementId: 'G-JHSDQ9QEC4',
    },
  },
  {
    domain: 'kiosk.daotienhotel.com',
    kiosk: true,
    firebaseConfig: {
      apiKey: 'AIzaSyAByTjrBmvNYmFTmoM-fdGiH9N3UQaA8ek',
      authDomain: 'autopms-production.firebaseapp.com',
      databaseURL: 'https://autopms-production-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'autopms-production',
      storageBucket: 'autopms-production.appspot.com',
      messagingSenderId: '759471927510',
      appId: '1:759471927510:web:2cd11548c9775a8b1f5977',
      measurementId: 'G-9NGMH39MC5',
    },
  },
]

export const environment = {
  production: true,
  baseUrl: '/api',
  sessionTimeout: 180,
  kiosk: false,
  ...hostingEnvironments.find((item) => item.domain === window.location.host),
}
